import { useTranslation } from 'react-i18next'
import { DocumentPreviewPanel } from './document-preview-panel'
import { PreviewDialog } from './preview-dialog'
import type { DocumentPreviewPanelProps } from './document-preview-panel'

/** Opens a single document; the target is resolved only while it is open. */
export function DocumentPreviewDialog({
  open,
  onOpenChange,
  ...panel
}: DocumentPreviewPanelProps & {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const { t } = useTranslation('documentPreview')

  return (
    <PreviewDialog
      open={open}
      onOpenChange={onOpenChange}
      title={panel.fileName}
      description={t('dialogDescription')}
      closeLabel={t('close')}
    >
      {open ? <DocumentPreviewPanel {...panel} /> : null}
    </PreviewDialog>
  )
}
